import { makeActionCreator } from '../App_Code/Utils';
import { ActMes } from '../App_Data/ActionTypes';
import { obtenirMessages } from '../App_Code/API';

export function mesObtenirMessages() {
    return (dispatch) => {
        dispatch({ type: ActMes.MES_CHARGEMENT });
        obtenirMessages().then((messages) => {
            dispatch({ type: ActMes.MES_AJOUT, data: messages });
        });
    };
}

export const mesDateDebut = makeActionCreator(ActMes.MES_DATE_DEBUT, 'data');

export const mesMarquerVuParClient = makeActionCreator(ActMes.MES_MARQUER_VU_PAR_CLIENT, 'data');



// WEBPACK FOOTER //
// ./src/Actions/MesActions.js